/* Filters the cards already rendered in one treatment category or directory. */
if (!customElements.get('laserlab-treatment-filter')) {
  customElements.define('laserlab-treatment-filter', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.form = this.querySelector('[data-filter-form]');
      this.input = this.querySelector('[data-filter-input]');
      this.count = this.querySelector('[data-filter-count]');
      this.empty = this.querySelector('[data-filter-empty]');
      this.clear = this.querySelector('[data-filter-clear]');
      if (!this.form || !this.input || !this.count) return;

      this.cards = Array.from(this.querySelectorAll('[data-filter-card]')).map(card => {
        let tags = [];
        try { tags = JSON.parse(card.dataset.filterTags || '[]'); } catch (_) { /* Cards without tags remain searchable. */ }
        const labels = Array.isArray(tags) ? tags.map(tag => String(tag).replace(/^tag__[^_]+_/, '')) : [];
        const visibleCopy = Array.from(card.querySelectorAll('.product-card__title, .product-card__excerpt, .ll-treatment-card__family, .llt__new-heading, .llt__new-copy, .llt__new-badge'))
          .map(node => node.textContent).join(' ');
        const groups = (card.dataset.filterGroups || '').split('|').filter(Boolean);
        return { card, groups, text: this.normalize(`${visibleCopy} ${labels.join(' ')}`) };
      });

      this.onInput = () => this.filter();
      this.onSubmit = event => { event.preventDefault(); this.filter(); };
      this.onReset = event => {
        clearTimeout(this.resetTimer);
        // A trusted reset click can run microtasks before the browser restores
        // form values. Wait until that native default action has completed.
        this.resetTimer = setTimeout(() => {
          if (event.defaultPrevented || !this.initialized) return;
          this.filter();
          this.input.focus({ preventScroll: true });
        }, 0);
      };
      this.onClearResult = event => {
        if (!event.target.closest('[data-filter-reset]')) return;
        if (this.typeSelect) this.typeSelect.value = 'all';
        this.form.reset();
      };
      this.input.addEventListener('input', this.onInput);
      this.input.addEventListener('search', this.onInput);
      this.form.addEventListener('submit', this.onSubmit);
      this.form.addEventListener('reset', this.onReset);
      this.addEventListener('click', this.onClearResult);
      this.typeSelect = this.querySelector('[data-filter-type-select]');
      this.onPageShow = () => this.filter();
      window.addEventListener('pageshow', this.onPageShow);
      this.onTypeChange = () => this.filter();
      this.typeSelect?.addEventListener('change', this.onTypeChange);
      const typeControl = this.querySelector('[data-filter-types]');
      if (typeControl) typeControl.hidden = false;
      this.classList.add('is-enhanced');
      this.form.hidden = false;
      this.initialized = true;
      this.filter();
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      clearTimeout(this.resetTimer);
      this.input.removeEventListener('input', this.onInput);
      this.input.removeEventListener('search', this.onInput);
      this.form.removeEventListener('submit', this.onSubmit);
      this.form.removeEventListener('reset', this.onReset);
      this.removeEventListener('click', this.onClearResult);
      this.typeSelect?.removeEventListener('change', this.onTypeChange);
      window.removeEventListener('pageshow', this.onPageShow);
      this.initialized = false;
    }

    normalize(value) {
      return String(value).toLocaleLowerCase('nb-NO')
        .replace(/æ/g, 'ae').replace(/ø/g, 'o')
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^\p{L}\p{N}\s]/gu, ' ').replace(/\s+/g, ' ').trim();
    }

    filter() {
      const query = this.normalize(this.input.value);
      const terms = query ? query.split(' ') : [];
      const type = this.typeSelect?.value || 'all';
      const active = Boolean(query) || type !== 'all';
      let matches = 0;
      this.cards.forEach(({ card, text, groups }) => {
        const visible = (type === 'all' || groups.includes(type)) && terms.every(term => text.includes(term));
        card.hidden = !visible;
        if (visible) matches += 1;
      });
      const total = this.cards.length;
      const singular = this.dataset.filterSingular || 'behandling';
      const plural = this.dataset.filterPlural || 'behandlinger';
      const noun = total === 1 ? singular : plural;
      const pageOnly = this.dataset.filterPageOnly === 'true' ? ' på denne siden' : '';
      this.count.textContent = active ? `${matches} av ${total} ${noun}${pageOnly}` : `${total} ${noun}${pageOnly}`;
      if (this.clear) this.clear.hidden = !this.input.value;
      if (this.empty) this.empty.hidden = !active || matches > 0;
    }
  });
}
